export class Action {
    id: number;
    code: string;
    libelle: string;
    montant: number;
    date_debut: any;
    date_fin: any;
    duree: number;
    poids: number | null;
    programme_id: any;
    agence_mo: string | null;

    agence_coord: string | null;
    mo: string | null;
    objectif_global: string | null;
    objectif_specifique: string | null;
    observations: string | null;
    perspectives: string | null;
    personnes_a_contacter: string | null;
    mt_fadec: number;
    mt_fadec_non_affecte: number;
    mt_mairie: number;
    mt_partenaire: number;
    resultat: any;
    zone_intervention: string | null;

    private errorMessage: string;

    constructor() {
        this.id = 0;
        this.code = "";
        this.libelle = "";
        this.montant = 0;
        this.date_debut = new Date();
        this.date_fin = new Date();
        this.duree = 0;
        this.poids = null;
        this.programme_id = 0;
        this.agence_mo = null;
        this.agence_coord = null;
        this.mo = null;
        this.objectif_global = null;
        this.objectif_specifique = null;
        this.observations = null;
        this.perspectives = null;
        this.personnes_a_contacter = null;
        this.mt_fadec = 0;
        this.mt_fadec_non_affecte = 0;
        this.mt_mairie = 0;
        this.mt_partenaire = 0;
        this.resultat = 0;
        this.zone_intervention = null;

        this.errorMessage = "";
    }

    canSave(): boolean {
        this.errorMessage = "";

        if (!this.libelle.trim()) {
            this.errorMessage = "Le libellé est requis.";
            return false;
        }

        if (!this.code.trim()) {
            this.errorMessage = "Le code est requis.";
            return false;
        }

        // if (this.montant <= 0) {
        //     this.errorMessage = "Le montant doit être supérieur à 0.";
        //     return false;
        // }

        // if (this.date_fin < this.date_debut) {
        //     this.errorMessage = "La date de fin ne peut pas être antérieure à la date de début.";
        //     return false;
        // }

        // if (this.duree < 0) {
        //     this.errorMessage = "La durée ne peut pas être négative.";
        //     return false;
        // }

        if (this.programme_id <= 0) {
            this.errorMessage = "Un programme doit être sélectionné.";
            return false;
        }

        // if (this.mt_fadec < 0 || this.mt_fadec_non_affecte < 0 || this.mt_mairie < 0 || this.mt_partenaire < 0) {
        //     this.errorMessage = "Les montants financiers ne peuvent pas être négatifs.";
        //     return false;
        // }

        if (this.resultat < 0) {
            this.errorMessage = "Le résultat doit être un nombre positif.";
            return false;
        }

        // if (this.zone_intervention <= 0) {
        //     this.errorMessage = "Une zone d'intervention doit être sélectionnée.";
        //     return false;
        // }

        return true;
    }

    getErrorMessage(): string {
        return this.errorMessage;
    }
}
